import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/pt-br';
import { Typography, Grid2 } from '@mui/material';
import { Box } from '@mui/system';
import { Trans, useTranslation } from 'react-i18next';
import { styles } from './styles';
import { dateFormatter } from '@/utils/dateFormatter';
import EmptyStateBooked from '@/assets/scheduling/empty_state_schedule_booked.svg';

type TimeListProps = {
  allTimes: any;
  selectedDay: any;
  timeItem: any;
  internalObject: any;
};

export const TimeList = ({
  allTimes,
  selectedDay,
  timeItem,
  internalObject,
}: TimeListProps) => {
  const { t } = useTranslation('schedule');
  const { emptyStateSchedule } = dateFormatter();
  const findDate = allTimes.find((times: any) => {
    return (
      moment(selectedDay).format('YYYY-MM-DD') ===
      moment(times.date).format('YYYY-MM-DD')
    );
  });
  const emptyState = () => {
    return (
      <Box sx={styles.emptyState}>
        <Box component="img" src={EmptyStateBooked} />
        <Typography>
          <Trans
            i18nKey="schedule:screen_choose_date_no_time"
            values={{ date: emptyStateSchedule(selectedDay) }}
            components={{ bold: <span style={styles.emptyStateDay} /> }}
          />
        </Typography>
      </Box>
    );
  };

  return allTimes.length > 0 && findDate !== undefined ? (
    <Box>
      <Typography sx={styles.timeTitle}>
        {t('screen_choose_confirm_schedule_time')}
        <span
          style={{
            display: 'block',
            fontWeight: 400,
            fontSize: '1.4rem',
            marginTop: 1,
          }}
        >
          {`Convertido para o seu fuso local (${
            Intl.DateTimeFormat().resolvedOptions().timeZone
          })`}
        </span>
      </Typography>
      <Grid2 container columns={4} sx={styles.hoursList}>
        {findDate?.items.map((date: any, index: any) => timeItem(date, index))}
      </Grid2>
    </Box>
  ) : internalObject.passedDateSelect ? (
    <Box />
  ) : (
    emptyState()
  );
};
